import PositionsList from 'components/Lists/ListView/PositionsList';
import RestaurantsList from 'components/Lists/ListView/RestaurantsList';
import Text from 'components/Text/Text';
import React, { useContext, useState } from 'react';
import { ICategoryContext, CategoryContext } from '../../../../../categoryState/categoryContext';
import { RequestEntity, UserRoles, IItemCategory } from 'types';
import { categoryTypes, typesOfCategoriesDeniedForClientManagers } from 'appConstants';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import DataController from 'components/DataController/DataController';
import { useRoleAccess } from 'hooks/useRoleAccess';
import Info from './components/Info/Info';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemCategory;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const { setIDForDeletion } = useContext<ICategoryContext>(CategoryContext);
	const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false);
	const isDeniedForManagers = typesOfCategoriesDeniedForClientManagers.includes(data.categoryType);
	const hasEditAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		isDeniedForManagers ? UserRoles.NON_EXISTENT_ROLE : UserRoles.CLIENT_MANAGER,
		isDeniedForManagers ? UserRoles.NON_EXISTENT_ROLE : UserRoles.GROUP_MANAGER,
		UserRoles.RESTAURANT_MANAGER,
		UserRoles.TECHNICAL,
		UserRoles.WAITER,
		UserRoles.RKL_SUPPORT_MANAGER,
	]);
	const containerClasses = classNames(style.container, { [style.openInfo]: isOpenInfo });
	const categoryRowClasses = classNames(style.category, style.row);
	const categoryNameClasses = classNames(style.categoryName);
	const categoryTypeRowClasses = classNames(style.categoryType, style.row);
	const positionRowClasses = classNames(style.position, style.row, style.list);
	const restaurantRowClasses = classNames(style.restaurant, style.row, style.list);
	const customerRowClasses = classNames(style.customer, style.row);
	const actionRowClasses = classNames(style.action, style.row);

	const categoryTypeName = categoryTypes.find((el) => el.categoryID === data.categoryType)?.categoryName || null;

	return (
		<div data-test={`Item-${index}`}>
			<div className={containerClasses}>
				<div className={categoryRowClasses}>
					<div className={style.imgWrapper}>
						<ImgUploaderByEntityId
							resource={RequestEntity.Categories}
							entityID={data.filePath ? data.id : ''}
							photoSize="Small"
							loaderSize="small"
							filePath={data.filePath}
						/>
					</div>
					<Text
						className={categoryNameClasses}
						translationKey={data.name}
						withTooltip={true}
						data-test="categoryName"
					/>
				</div>
				<Text
					className={categoryTypeRowClasses}
					translationNameSpace="listing"
					translationKey={categoryTypeName}
					withTooltip={true}
					data-test="categoryType"
				/>
				<div className={positionRowClasses}>
					<PositionsList restaurants={data.restaurantsCategories} />
				</div>
				<div className={restaurantRowClasses}>
					<RestaurantsList restaurants={data.restaurantsCategories} />
				</div>
				<Text
					className={customerRowClasses}
					translationKey={data.customerName}
					withTooltip={true}
					data-test="customerName"
				/>
				<div className={actionRowClasses}>
					<DataController
						onClickInfo={() => setIsOpenInfo(!isOpenInfo)}
						onClickDelete={() => setIDForDeletion(data.id)}
						URLWithIDToEdit={hasEditAccess ? `/menu/category/edit?categoryID=${data.id}` : undefined}
						size="smallBtn"
						isOpenInfo={isOpenInfo}
					/>
				</div>
			</div>
			<Info isOpenInfo={isOpenInfo} data={data} categoryTypeName={categoryTypeName} />
		</div>
	);
};

export default Item;
